<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2">
      <gmap-map
        :zoom="14"
        :center="position"
        style="width:100%;  height: 400px;">
        <gmap-marker
          :position="position">
        </gmap-marker>
      </gmap-map>
    </div>

  </div>

</template>

<script >

export default {

  name: 'ShowAddressMap',

  data() {
    return {
      position: {
        lat: this.latitude,
        lng: this.longitude
      }
    }
  },

  props: {
    latitude: {
      type: Number,
      default: null
    },
    longitude: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowAddressMap.vue